import { useContext } from "react";
import { AuthContext } from "./AuthContext";

const useAuthGlobal = () => useContext(AuthContext);
export default useAuthGlobal;
